import { create } from 'zustand';

export type UsageType = 'searches' | 'batch_exports' | 'wallet_exports';

interface UsageLimitState {
  isOpen: boolean;
  usageType: UsageType | null;
  current: number;
  limit: number;
  resetDate?: string;
  showModal: (data: {
    usageType: UsageType;
    current: number;
    limit: number;
    resetDate?: string;
  }) => void;
  hideModal: () => void;
}

export const useUsageLimitStore = create<UsageLimitState>((set) => ({
  isOpen: false,
  usageType: null,
  current: 0,
  limit: 0,
  resetDate: undefined,
  showModal: (data) =>
    set({
      isOpen: true,
      usageType: data.usageType,
      current: data.current,
      limit: data.limit,
      resetDate: data.resetDate,
    }),
  hideModal: () =>
    set({
      isOpen: false,
      usageType: null,
      current: 0,
      limit: 0,
      resetDate: undefined,
    }),
}));

// Helper function to handle 429 responses
export const handleUsageLimitError = (errorResponse: {
  error: string;
  message: string;
  usageType: UsageType;
  current: number;
  limit: number;
  resetDate?: string;
}) => {
  const { showModal } = useUsageLimitStore.getState();
  showModal({
    usageType: errorResponse.usageType,
    current: errorResponse.current,
    limit: errorResponse.limit,
    resetDate: errorResponse.resetDate,
  });
};